import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=7f5a5f03&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"
import style0 from "./recommend.vue?vue&type=style&index=0&id=7f5a5f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a5f03",
  null
  
)

export default component.exports